require('./brokerExanteProfitabilityCosts.scss')

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @components
const BrokerExanteProfitabilityCostsSubSection = require('components/commons/brokerExanteProfitabilityCostsSubSection/brokerExanteProfitabilityCostsSubSection');
const BrokerExanteProfitabilityCostsItem = require('components/commons/brokerExanteProfitabilityCostsItem/brokerExanteProfitabilityCostsItem');

class BrokerExanteProfitabilityCosts extends React.Component {
    buildKey(key) {
        const { context } = this.props;
        return `${context}-${key}`
    }

    buildDetails() {
        const { section, context, eventCategory, complexTooltip } = this.props;
        if (!!section.get('details')) {
            return section
                .get("details")
                .map((detail, index) => (
                    <BrokerExanteProfitabilityCostsSubSection
                        section={detail}
                        context={context}
                        key={index}
                        eventCategory={eventCategory}
                        sectionTitle={section.get("descriptionKey")}
                        complexTooltip={complexTooltip}
                    />
                ));
        }
    }

    render() {
        const { section, context, eventCategory, complexTooltip } = this.props;
        const separator = !!section.get('details') && (<div className="broker-ex-ant-profitability-cost__section-total-separator" />);
        return (
            <div className="broker-ex-ant-profitability-cost__section">
                <div className="broker-ex-ant-profitability-cost__section-details">
                    {this.buildDetails()}
                </div>
                <div className="broker-ex-ant-profitability-cost__section-total">
                    {separator}
                    <BrokerExanteProfitabilityCostsItem
                        data={section.get('total')}
                        context={context}
                        sectionTitle={this.buildKey(section.get('descriptionKey'))}
                        eventCategory={eventCategory}
                        complexTooltip={complexTooltip}
                    />
                </div>
            </div>
        );
    }
}
BrokerExanteProfitabilityCosts.defaultProps = {
    complexTooltip: false,
}

BrokerExanteProfitabilityCosts.propTypes = {
    section: PropTypes.object,
    context: PropTypes.string,
    eventCategory: PropTypes.string,
    complexTooltip: PropTypes.bool,
}
module.exports = BrokerExanteProfitabilityCosts;